import { render, staticRenderFns } from "./Form10ProcessHeader.vue?vue&type=template&id=02fd3585&scoped=true"
import script from "./Form10ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form10ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form10ProcessHeader.vue?vue&type=style&index=0&id=02fd3585&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fd3585",
  null
  
)

export default component.exports